import * as api from '../api/visitsApi';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as types from '../constants/visitsConstants';
import { toast } from 'react-toastify';

export const getVisitsActions = (search, vin) => async (dispatch) => {
  dispatch({ type: types.GET_VISITS_REQUEST });
  try {
    const { error, data } = await api.getVisits(search, vin);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_VISITS_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список візитів');
    dispatch({ type: types.GET_VISITS_FAILURE });
  }
};

export const createVisitAction = (vin, navigate) => async () => {
  try {
    const { error, data } = await api.createVisit(vin);
    if (error) {
      throw new Error(error);
    }
    navigate(`/vehicles/${vin}/visits/${data.id}`);
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати візит');
  }
};

export const clearVisitsActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_VISITS,
  });
};

export const setVisitsPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_VISITS_PAGE_SIZE,
    payload: pageSize,
  });
};

export const nextVisitsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_VISITS_PAGE,
  });
};

export const prevVisitsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_VISITS_PAGE,
  });
};
